import { MAP_NAMES, mapFromUrl, levelUrl } from '../shared/maps.ts'
import { showLoading } from './hud/loading.ts'
import { createMenu } from './hud/menu.ts'
import { watchGamepads } from './game/gamepad.ts'

const url = new URL(location.href)
const routeMap = mapFromUrl(url)
const isHome = !routeMap && (url.pathname === '/' || url.pathname === '/index.html')
const selectedMap = routeMap ?? 'blood-gulch'
if (!routeMap && !isHome) {
  location.replace('/')
} else {
  if (!isHome) history.replaceState(null, '', levelUrl(selectedMap, url))
  document.title = `${MAP_NAMES[selectedMap]} · nothalo`
  const scripted = ['cam', 'nooverlay', 'offline'].some(key => url.searchParams.has(key))
  const backdrop = document.querySelector<HTMLElement>('.menu-backdrop')!
  if(['blood-gulch','guardian','lockout'].includes(selectedMap))backdrop.style.backgroundImage = `url('/assets/menu/${selectedMap}.jpg')`
  if (scripted) {
    document.querySelector('#menu-shell')?.remove()
    backdrop.remove()
  }
  if (!scripted) watchGamepads()
  const loading = showLoading(MAP_NAMES[selectedMap])
  const menu = scripted ? undefined : createMenu(selectedMap, loading.stage)
  menu?.onSelect(() => loading.reset())
  try {
    loading.stage('Starting camera…')
    // Give the initial HTML (logo, fields, level still) a paint before evaluating the renderer.
    await new Promise<void>(resolve => requestAnimationFrame(() => requestAnimationFrame(() => resolve())))
    const { startGame } = await import('./game-entry.ts')
    await startGame(menu?.selectedMap ?? selectedMap, loading.stage, menu, () => { menu?.fail(); loading.fail() })
  } catch (error) {
    console.error('Level startup failed:', error)
    menu?.fail()
    loading.fail()
  }
}
